import React from 'react';
import {Menu, MenuItem, useTheme} from '@mui/material';
import {ContextMenuProps} from './types';
import {useMediaQueries} from 'presentation/pages';
import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new/index';

const {exclude, edit} = translations['pt-br'].commons;

export function ContextMenu({
	anchorContextMenuEl,
	isMenuOpen,
	handleContextMenuClose,
	handleEdit,
	handleDelete,
}: ContextMenuProps) {
	const menuId = 'context-menu';
	const {colors} = useTheme();
	const baseStyle = {fontWeight: 600, fontSize: '14px'};
	const {isMobile} = useMediaQueries();

	if (isMobile) {
		return (
			<Drawer.Root
				open={isMenuOpen}
				onOpen={() => {}}
				onClose={handleContextMenuClose}
				swipeAreaWidth={0}>
				<Drawer.Footer
					hideFirstButton={!handleDelete}
					firstButtonColor="error"
					firstButtonTitle={exclude}
					firstButtonOnClick={
						handleDelete &&
						(() => {
							handleContextMenuClose();
							handleDelete();
						})
					}
					firstButtonDataTagId="context-menu-delete"
					secondButtonTitle={edit}
					secondButtonOnClick={() => {
						handleContextMenuClose();
						handleEdit();
					}}
					secondButtonDataTagId="context-menu-edit"
					canStacks
				/>
			</Drawer.Root>
		);
	}

	return (
		<Menu
			anchorEl={anchorContextMenuEl}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			id={menuId}
			keepMounted
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={isMenuOpen}
			onClose={handleContextMenuClose}
			elevation={5}>
			<MenuItem
				onClick={() => {
					handleContextMenuClose();
					handleEdit();
				}}
				sx={{...baseStyle, color: colors.light.primary.main}}>
				{edit}
			</MenuItem>
			{handleDelete && (
				<MenuItem
					onClick={() => {
						handleContextMenuClose();
						handleDelete();
					}}
					sx={{...baseStyle, color: colors.light.error.main}}>
					{exclude}
				</MenuItem>
			)}
		</Menu>
	);
}
